import { io } from "socket.io-client";
export const url = "https://sragency.api.invetix.in/api"
export const socket = io("https://sragency.api.invetix.in");
